import { Row } from "reactstrap";
import CourseCategories from "./CourseCategories";
import CategoriesCheckBoxes from "./Categories";
import UpcomingCourses from "./UpcomingCourses";
import { LearningFilter } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

const CourseFilter = () => {
  return (
    <div className="md-sidebar">
      <Btn color="primary" tag="a" className="email-aside-toggle md-sidebar-toggle">{LearningFilter}</Btn>
      <div className="md-sidebar-aside job-sidebar">
        <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
          <Row>
            <CourseCategories />
            <CategoriesCheckBoxes />
            <UpcomingCourses />
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CourseFilter;
